/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { ConstructionMethodBase } from "../../../../schema/generated/ConstructionMethod";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class ConstructionMethodDataApi extends EntityDataApi<ConstructionMethodBase> {
  public readonly def = idbEntityDefs.ConstructionMethod;
}